// 📁 src/lightversion/ProComingSoonLite.jsx

import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  Button,
  Chip,
  Alert,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLite } from "./context/LiteContext";
import LiteDayGate from "./LiteDayGate";

const ProComingSoonLite = () => {
  const navigate = useNavigate();
  const { 
  liteJourney,
  entryDecided,
  loading: liteLoading
  } = useLite();

  /* --------------------------------------------------
   🔒 ENTRY DECISION GUARD
-------------------------------------------------- */
useEffect(() => {

  if (liteLoading) return;

  if (!entryDecided && window.location.pathname !== "/lite/welcome") {
    navigate("/lite/welcome",{replace:true});
  }

  }, [entryDecided, liteLoading, navigate]);

  useEffect(() => {
    if (typeof window !== "undefined" && window.mdihTrack) {
      window.mdihTrack("lite_pro_waitlist_viewed", {
        purpose: liteJourney?.purpose?.statement,
        hasDirection: !!liteJourney?.direction,
      });
    }
  }, [liteJourney?.purpose, liteJourney?.direction]);

  return (
    <LiteDayGate allow={["ELIGIBLE_FOR_PRO", "EARLY_ACCESS"]}>
      <Box sx={{ maxWidth: 860, mx: "auto", p: 4 }}>
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Chip
            label="Early Access • Pro"
            color="primary"
            sx={{ mb: 2 }}
          />

          <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
            You’re early — and that’s intentional
          </Typography>

          <Typography color="text.secondary" sx={{ mb: 4 }}>
            MDIH Pro is currently in limited early access.  
            We’re refining it carefully with serious builders before opening it publicly.
          </Typography>
        </motion.div>

        {/* CONTEXT CARD */}
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Stack spacing={2}>
              <Typography variant="subtitle2">
                Your Lite journey so far
              </Typography>

              <Typography variant="body2">
                <strong>Purpose:</strong>{" "}
                {liteJourney?.purpose?.statement || "—"}
              </Typography>

              {liteJourney?.direction && (
                <Typography variant="body2">
                  <strong>Direction:</strong>{" "}
                  {liteJourney.direction.title}
                </Typography>
              )}

              <Typography variant="body2">
                <strong>Status:</strong> Early access interest recorded
              </Typography>
            </Stack>
          </CardContent>
        </Card>

        {/* WHAT’S COMING */}
        <Card sx={{ mb: 4, backgroundColor: "#f9fafb" }}>
          <CardContent>
            <Typography fontWeight="bold" sx={{ mb: 1 }}>
              What Pro will unlock (soon)
            </Typography>

            <ul style={{ paddingLeft: 18, marginTop: 8 }}>
              <li>Structured problem → solution → MVP journey</li>
              <li>AI-guided validation & iteration loops</li>
              <li>Founder-focused tools (no fluff, no hype)</li>
              <li>Designed for students & early builders in India</li>
            </ul>
          </CardContent>
        </Card>

        {/* REASSURANCE */}
        <Alert severity="info" sx={{ mb: 4 }}>
          <Typography variant="body2">
            You don’t need to decide or pay anything right now.  
            When Pro opens, you’ll be notified — and you’ll get first access.
          </Typography>
        </Alert>

        {/* CTA */}
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/lite/learning")}
          >
            Continue learning in Lite →
          </Button>

          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/")}
          >
            Exit for now
          </Button>
        </Stack>
      </Box>
    </LiteDayGate>
  );
};

export default ProComingSoonLite;
